import request from "@/utils/request";

// 根据选址记录ID预览远方好物报告数据
export const getBfhwDataById = (addrId) => {
  return request({
    url: '/center-bh-pro-biz-core/survey/baseDistantGoods',
    method: 'POST',
    data: {
      addrId,
    },
  });
}